module.exports = __webpack_public_path__ + "static/media/blog1.5c543858.jpg";